import * as Configuration from '../app.constants.js';

const HTTP = new WeakMap();
const MODAL = new WeakMap();
const RELOAD_MODAL_IS_OPEN = new WeakMap();
const ROOTSCOPE = new WeakMap();
const LOCATION = new WeakMap();
const STATE = new WeakMap();
const WINDOW = new WeakMap();

export class AppService {
  constructor($http, $uibModal, $rootScope, $location, $state, $window) {
    HTTP.set(this, $http);
    MODAL.set(this, $uibModal);
    RELOAD_MODAL_IS_OPEN.set(this, false);
    ROOTSCOPE.set(this, $rootScope);
    LOCATION.set(this, $location);
    STATE.set(this, $state);
    WINDOW.set(this, $window);
  }

  checkJsVersion(innerVersion, serverVersion) {
    if (serverVersion != innerVersion) {
      return false;
    }
    return true;
  }

  getAvailableLanguages() {
    return ['fr', 'en', 'es', 'nl', 'ru', 'tr', 'it', 'de'];
  }

  getAvailableLocales() {
    return {
      'en' : 'en-us',
      'fr' : 'fr-fr',
      'es' : 'es-es',
      'nl' : 'nl-nl',
      'ru' : 'ru-ru',
      'tr' : 'tr-tr',
      'it' : 'it-it',
      'de' : 'de-de'
    };
  }

  resolveUrl(companyId, shortUrl, resolvedCallback) {
    return HTTP.get(this).post(Configuration.constants.baseUrl + companyId + '/url-resolve', {
      'url': shortUrl
    }).then(result => resolvedCallback(result.data.long_url));
  }

  static AppFactory($http, $uibModal, $rootScope, $location, $state, $window) {
    return new AppService($http, $uibModal, $rootScope, $location, $state, $window);
  }
}
AppService.AppFactory.$inject = ['$http', '$uibModal', '$rootScope', '$location', '$state', '$window'];
